import { CAST_AI } from '@cast/constants';
import { Button, HexIcon, Icons, Stack, Typography } from '@cast/design-system';
import { useAssignCredentialsDialogV2 } from '@cast/split-me/hooks';

import { useCluster } from '@cast/shared-cluster-context-data-access';

export const ActionRequired = () => {
  const { cluster } = useCluster();
  const { openAssignCredentialsDialog } = useAssignCredentialsDialogV2();

  return (
    <Stack
      alignItems="center"
      alignSelf="center"
      gap={8}
      mt={16}
      data-testid="gpu-action-required-message"
    >
      <HexIcon
        variant="notification"
        icon={<Icons.Polygon weight="fill" />}
        size={72}
      />

      <Stack gap={4} mb={16}>
        <Typography variant="h5" textAlign="center">
          Action required
        </Typography>

        <Typography variant="P14R" color="textSecondary">
          Please install the GPU metrics collection component to see GPU
          utilization metrics.
        </Typography>
      </Stack>

      <Button
        testId="enable-gpu-metrics-button"
        variant="primary"
        size="md"
        onClick={() =>
          openAssignCredentialsDialog({
            cluster,
            productName: 'gpuMetricsExporter',
          })
        }
      >
        Enable {CAST_AI}
      </Button>
    </Stack>
  );
};
